<template>
  <div>
    <NotProjectAlert ref="NotProjectAlert" :show="true"></NotProjectAlert>
  </div>
</template>

<script>
import NotProjectAlert from './components/not-project'
export default {
  name: 'not-project',
  components: {
    NotProjectAlert
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
